import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthService, PermissionsByRoute } from "@nstep-common/core";

export function authGuard(permissionsByRoute: PermissionsByRoute): CanActivateFn {
	return (_, state: RouterStateSnapshot): boolean => {
		const authService = inject(AuthService);

		const permissions = permissionsByRoute.get(state.url.substring(1));

		if (!authService.hasAccess(...permissions)) {
			authService.redirectToLogin(true);
			return false;
		}

		return true;
	};
}
